import moment from "moment";
import _ from "lodash";
import { normalizeValorEmail } from "../common/FiltroUtil";
/**
 * Intervalos permitidos para agendamento de um job que possui um filtro para escolher.
 */
export var FiltroIntervalo;
(function (FiltroIntervalo) {
    FiltroIntervalo["MES_ANTERIOR"] = "M\u00EAs anterior";
    FiltroIntervalo["SEMANA_ANTERIOR"] = "Semana anterior";
    FiltroIntervalo["ULTIMOS_7DIAS"] = "\u00DAltimos 7 dias";
    FiltroIntervalo["ULTIMOS_30DIAS"] = "\u00DAltimos 30 dias";
})(FiltroIntervalo || (FiltroIntervalo = {}));
/**
 * Criar um filtro a partir das opções selecionadas pelo usuário.
 *
 * @param filtroIntervaloValor
 * @param filtroIntervaloVariavel
 */
export const montarFiltroSecundario = (filtroIntervaloValor, filtroIntervaloVariavel) => {
    console.log(filtroIntervaloValor);
    let end, start;
    switch (filtroIntervaloValor) {
        case FiltroIntervalo.MES_ANTERIOR:
            const refMonth = moment().subtract(1, 'months');
            end = refMonth.endOf('month').toDate();
            start = refMonth.startOf('month').toDate();
            break;
        case FiltroIntervalo.SEMANA_ANTERIOR:
            const refWeek = moment().subtract(1, 'week');
            end = refWeek.endOf('week').toDate();
            start = refWeek.startOf('week').toDate();
            break;
        case FiltroIntervalo.ULTIMOS_7DIAS:
            end = moment().toDate();
            start = moment().subtract(7, 'days').toDate();
            break;
        case FiltroIntervalo.ULTIMOS_30DIAS:
            end = moment().toDate();
            start = moment().subtract(30, 'days').toDate();
            break;
    }
    console.log([start, end]);
    return {
        atributo: filtroIntervaloVariavel,
        tipoComponente: 'BETWEEN_INCLUSIVE_TIMESTAMP_MS',
        valor: () => [start, end],
    };
};
/**
 * Montar nome do arquivo único e sem caracteres especiais.
 */
export const montarNomeArquivo = (titulo, tipo = 'xlsx') => {
    const newTitulo = _.kebabCase(titulo);
    return `${newTitulo}${new Date().getTime()}.${tipo}`;
};
export const montarFiltrosEmail = (nFiltros, metaAtributos) => {
    return nFiltros.map(({ atributo, valor, tipoComponente }) => {
        // [1] Recuperar o nome da variável
        const meta = metaAtributos.find((e) => e.atributo === atributo);
        const eVariavel = (meta === null || meta === void 0 ? void 0 : meta.rotulo) || atributo;
        // [2] Montar o valor de acordo com sua operação.
        const nValor = normalizeValorEmail({ valor, tipoComponente });
        return {
            eVariavel,
            eValor: nValor
        };
    });
};
export const disassembleRepeat = ({ day, hourFormat, dayOfWeek }) => {
    let alg = ["6", "0", "1", "*", "*"]; // default
    if (day) {
        alg[2] = day;
    }
    else if (dayOfWeek) {
        alg[4] = dayOfWeek;
    }
    if (hourFormat) {
        const [hour, minute] = hourFormat.split(":");
        alg[0] = minute;
        alg[1] = hour;
    }
    return alg.join(" ");
};
const assemble = (cron = "00 6 * * *") => {
    const alg = cron.split(" ");
    if (alg.length !== 5) {
        console.warn("Problema na cron");
        return ["1", "06:00"];
    }
    const hour = alg[1] === "*" ? 6 : Number(alg[1]);
    const minute = alg[0] === "*" ? 0 : Number(alg[0]);
    const time = moment({
        hour, minute, second: 0,
    });
    const hourFormat = time.format("HH:mm");
    // Regra para escolher um ou outro
    let day, dayOfWeek;
    dayOfWeek = alg[4] === "*" ? null : alg[4];
    if (!dayOfWeek) {
        day = alg[2] === "*" ? "1" : alg[2];
    }
    return [day, hourFormat, dayOfWeek];
};
export const assembleRepeat = (cron) => {
    const [day, hour, dayOfWeek] = assemble(cron);
    const tipoCron = dayOfWeek ? 'Semanal' : 'Mensal';
    return [day, hour, dayOfWeek, tipoCron];
};
export const assembleRepeatText = (cron) => {
    const [day, hour, dayOfWeek, tipoCron] = assembleRepeat(cron);
    const daysOfWeeks = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'];
    switch (tipoCron) {
        case "Semanal":
            return `Toda ${daysOfWeeks[Number(dayOfWeek)]} de cada semana, às ${hour}`;
        case "Mensal":
            return `Todo dia ${day} de cada mês, às ${hour}`;
        default:
            return cron;
    }
};
